"use strict";

module.exports.Accordion = require("./Accordion")["default"];
module.exports.AssetContainer = require("./AssetContainer")["default"];
module.exports.Card = require("./Card")["default"];
module.exports.CardBrowser = require("./CardBrowser")["default"];
module.exports.CardBrowserFilter = require("./CardBrowserFilter")["default"];
module.exports.CardBrowserSearch = require("./CardBrowserSearch")["default"];
module.exports.CardBrowserSelectedDisplay = require("./CardBrowserSelectedDisplay")["default"];
module.exports.CardBrowserSelectedTools = require("./CardBrowserSelectedTools")["default"];
module.exports.CardBrowserSlider = require("./CardBrowserSlider")["default"];
module.exports.Checkbox = require("./Checkbox")["default"];
// module.exports.ColorPicker = require('./ColorPicker').default;
module.exports.Dialog = require("./Dialog")["default"];
module.exports.Form = require("./Form")["default"];
module.exports.Icon = require("./Icon")["default"];
module.exports.IconButton = require("./IconButton")["default"];
module.exports.ImageTag = require("./ImageTag")["default"];
module.exports.InputText = require("./InputText")["default"];
module.exports.LabelInfo = require("./LabelInfo")["default"];
module.exports.List = require("./List")["default"];
module.exports.ListItem = require("./List").ListItem;
module.exports.MenuItem = require("./MenuItem")["default"];
module.exports.Notification = require("./Notification")["default"];
module.exports.NavigationItem = require("./NavigationItem")["default"];
module.exports.PopupList = require("./PopupList")["default"];
module.exports.PopupListWithFilter = require("./PopupListWithFilter")["default"];
module.exports.PopupMenu = require("./PopupMenu")["default"];
module.exports.Select = require("./Select")["default"];
module.exports.Slider = require("./Slider")["default"];
module.exports.TextContainer = require("./TextContainer")["default"];
module.exports.Toggle = require("./Toggle")["default"];
module.exports.TableGrid = require("./TableGrid")["default"];
module.exports.SceneSlideshow = require("./Scenes/Slideshow")["default"];
module.exports.SceneCustomGame = require("./Scenes/CustomGame")["default"];

// module.exports = {
//   'Accordion': require('./Accordion').default,
//   'Card': require('./Card').default,
//   'CardBrowser': require('./CardBrowser').default,
//   'CardBrowserFilter': require('./CardBrowserFilter').default,
//   'CardBrowserSearch': require('./CardBrowserSearch').default,
//   'CardBrowserSelectedDisplay': require('./CardBrowserSelectedDisplay').default,
//   'CardBrowserSelectedTools': require('./CardBrowserSelectedTools').default,
//   'CardBrowserSlider': require('./CardBrowserSlider').default,
//   'Checkbox': require('./Checkbox').default,
//   'ColorPicker': require('./ColorPicker').default,
//   'Dialog': require('./Dialog').default,
//   'Form': require('./Form').default,
//   'Icon': require('./Icon').default,
//   'ImageTag': require('./ImageTag').default,
//   'InputText': require('./InputText').default,
//   'LabelInfo': require('./LabelInfo').default,
//   'List': require('./List').default,
//   'ListItem': require('./List').ListItem,
//   'MenuItem': require('./MenuItem').default,
//   'Notification': require('./Notification').default,
//   'PopupList': require('./PopupList').default,
//   'PopupListWithFilter': require('./PopupListWithFilter').default,
//   'PopupMenu': require('./PopupMenu').default,
//   'Select': require('./Select').default,
//   'Slider': require('./Slider').default,
//   'Toggle': require('./Toggle').default
// };